import { api } from './client';

export interface NginxInfo {
  version: string | null;
  active: boolean;
  server_block_count: number;
}

export interface NginxServerBlock {
  server_names: string[];
  listen: string[];
  root: string | null;
  proxy_pass: string | null;
  tls: boolean;
  source_file: string;
  parse_error: false;
}

export interface NginxParseError {
  source_file: string;
  parse_error: true;
  error: string;
}

export type NginxServer = NginxServerBlock | NginxParseError;

export const fetchWebserverInfo = (): Promise<NginxInfo> =>
  api.get<NginxInfo>('/webserver/info').then((r) => r.data);

export const fetchWebserverServers = (): Promise<{ servers: NginxServer[] }> =>
  api.get<{ servers: NginxServer[] }>('/webserver/servers').then((r) => r.data);
